import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Field, PasswordField, SubmitButton, FormMessage } from "@/components/Field";

export const LoginForm = ({ onSuccess, onForgot }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onSuccess(data);
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
      <Field label="Email" testId="login-email-input" type="email" placeholder="ton@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
      <PasswordField label="Mot de passe" testId="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} />
      <FormMessage error={error} />
      <SubmitButton testId="login-submit-button" loading={loading}>Accéder à mon espace</SubmitButton>
      <p className="text-center">
        <button data-testid="forgot-password-link" type="button" onClick={onForgot} className="link-bordeaux text-sm font-light">
          Mot de passe oublié ?
        </button>
      </p>
    </form>
  );
};
